<template>
  <div class="animated fadeIn">
    <b-card no-body>
      <b-card-body>
        <div v-if="loading">
          <loading></loading>
        </div>
        <div v-else>
          <table class="table table-hover table-bordered table-striped table-sm">
            <thead class="soft-grey">
              <tr class="text-center">
                <th rowspan="2" style="width: 30%;">Nama Produk</th>
                <th colspan="4" style="border-bottom:0px;">Total Barang</th>
              </tr>
              <tr class="text-center">
                  <th>Sebelumnya</th>
                  <th>Barang Masuk</th>
                  <th>Barang Keluar</th>
                  <th>Tersedia Saat Ini</th>
              </tr>
            </thead>

            <tbody v-if="haveData">
                <template v-for="(data, key) in history" >
                    <tr :key="uniqueId('history'+key)">
                        <td colspan="6" class="green font-c-white">{{key}}</td>
                    </tr>
                    <tr v-for="(val, index) in data" :key="uniqueId('detail'+index)" class="text-center">
                        <td class="text-left">&nbsp; &raquo;{{val.date_inserted}}   <label class="blink-blue" v-if="val.status === '1'"></label></td>
                        <td>{{formatPrice(val.past_qty)}}</td>
                        <td>{{formatPrice(val.income)}}</td>
                        <td>{{formatPrice(val.outcome)}}</td>
                        <td>{{formatPrice(val.available)}}</td>
                    </tr>
                </template>
            </tbody>
            <tbody v-else>
                <tr>
                    <td :colspan="6" class="text-center">No data</td>
                </tr>
            </tbody>
          </table>
        </div>
      </b-card-body>
    </b-card>
  </div>
</template>

<script>
import axios from "axios";
import VueNotifications from "vue-notifications";
import * as moment from "moment";
import "moment/locale/id";
import loading from "@/templates/Loading.vue";
import _ from "lodash";

export default {
  name: "history-detail",
  components: { loading },
  props: {
    tableDetail: {
      type: Boolean,
      default: true
    },
    warehouseId: {
      type: String,
      default: false
    }
  },
  data() {
    return {
      history: [],
      loading: false
    };
  },
  notifications: {
    showErrorNotification: {
      title: "Error Title",
      message: "Messages",
      type: "error"
    },
    showInfoNotification: {
      title: "Info Title",
      message: "Messages",
      type: "info"
    }
  },
   computed: {
      haveData: function() {
        let temp = Object.keys(this.history).length
        return (temp > 0) ? true : false;
      }
  },
  methods: {
    init: function() {
      this.loading = true;
      this.getData();
    },
    uniqueId: function(param = "") {
      return _.uniqueId(param);
    },
    getData: function() {
      this.axios
        .get("web/warehouse/detail-history/" + this.warehouseId + "/")
        .then(response => {
          let data = response.data.data;
          this.history = data;
        })
        .catch(error => {})
        .finally(() => {
          this.loading = false;
        });
    },
    expired: function(error, title) {
      if (error.response.status === 401) {
        localStorage.clear();
        this.$router.push({ path: "/login" });
        this.showErrorNotification({
          title: "Token Expired",
          message: "Your session has been expired"
        });
      } else {
        this.showErrorNotification({
          title: title,
          message: error.response.data.message
        });
      }
    },
    formatPrice(value) {
      let val = (value / 1).toFixed(0).replace(".", ",");
      return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
    }
  },
  mounted() {
    this.init();
  }
};
</script>

<style>

</style>
